import { render } from "./DialerPage.vue?vue&type=template&id=c556b726&scoped=true"
import script from "./DialerPage.vue?vue&type=script&lang=js"
export * from "./DialerPage.vue?vue&type=script&lang=js"

import "./DialerPage.vue?vue&type=style&index=0&id=c556b726&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c556b726"

export default script